<template>
    <div class="booklist">
        <div v-for="(book, i) in value" :key="i" @click="read(book, i)" class="item">
            <span>{{book.name}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default() {
                return {};
            }
        }
    },
    methods: {
        read(book, i) {
            this.$emit('open-modal',book, i);
        }
    }
}
</script>

<style lang="less" scoped>
.item {
    padding: .5em 1em;
    color: white;

    &:active {
        background: #7bf;
    }
}
</style>
